<template>
  <filtertron-tray-section
    v-if="category.createdAt"
    id="category-configurator-chapters"
    :title="lang.get('category.configuration.chapters.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <multiselect
        id="chapter-selector"
        id-property="slug"
        name="chapters[]"
        :options="options"
        :selected-options="category.chapterSlugs"
        :placeholder="lang.get('category.form.chapters.placeholder')"
        :select-all-label="lang.get('multiselect.select_all')"
        @selected="onSelected"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import _ from 'underscore';
import { mapState } from 'vuex';
import { Multiselect } from 'vue-bootstrap';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    Multiselect,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['chapters']),
    options() {
      return this.chapters.map(chapter => ({
        slug: chapter.slug,
        name: chapter.name
      }));
    }
  },
  methods: {
    onSelected(slugs) {
      if (
        !_.isEqual([...this.category.chapterSlugs].sort(), [...slugs].sort())
      ) {
        this.handleInput('chapterSlugs', slugs);
      }
    }
  }
};
</script>
